<section [ngClass]="breakpoint">
  <!-- Breakpoints -->
  <div class="screen-container" [ngClass]="breakpoint" *ngIf="breakpoint && registrationLink">
    <img class="bar" [src]="breakpointBar" alt="breakpoint-bar" [ngClass]="{ 'start-fade': isLoading, 'end-fade': !isLoading }" />
    <div class="iframe-container" [ngClass]="{ 'end-loading': !isLoading }" [style.background-color]="persona.options?.theme?.enable ? persona.options?.theme?.palette?.background : '#f7f7f7'">
      <iframe *ngIf="showIfram" (load)="disableLoading()" [src]="registrationLink" frameborder="0" style="width: 85%; margin: 0 auto;"></iframe>
    </div>
    <ng-container *ngIf="isLoading">
      <div class="spinner-container">
        <mat-spinner class="spinner"></mat-spinner>
      </div>
    </ng-container>
  </div>

  <!-- Preview -->
  <div
    class="event-preview"
    *ngIf="event && persona"
    [hidden]="breakpoint"
    [style.background-color]="persona.options?.theme?.enable ? persona.options?.theme?.palette?.background : '#f7f7f7'"
  >
    <div class="overlay"></div>
    <ngx-landing-header [event]="event" [persona]="persona" *ngIf="options?.branding?.isEnabled"></ngx-landing-header>
    @if (options?.timing?.isEnabled && showOption) {
      <app-event-timings-preview
        [eventId]="event.id"
        [publicStartDate]="event.public_start_date"
        [publicEndDate]="event.public_end_date"
        [timezone]="event.timezone"
        [timezoneOffsetString]="event.timezone_offset_string"
        [workspaceSlug]="event.workspace?.slug"
        [eventSlug]="event.slug"
      ></app-event-timings-preview>
    }
    <ngx-landing-description [persona]="persona" *ngIf="options?.about?.isEnabled" (descriptionChange)="onDescriptionChange($event)"></ngx-landing-description>
    <ngx-upload-input [event]="event" [options]="persona.landing_page_options" class="upload-input" *ngIf="options?.downloads?.isEnabled"></ngx-upload-input>
    <div class="map-container" *ngIf="options?.location?.isEnabled">
      <img class="w-100 mb-2 rounded-3" *ngIf="getStaticMapUrl()" [src]="getStaticMapUrl()" alt="" />
      <p class="address" *ngIf="event.location_details.venue_address">{{ event.location_details.venue_address }}</p>
    </div>
    <ngx-landing-registration [event]="event" [persona]="persona" *ngIf="options?.form?.isEnabled"></ngx-landing-registration>
    <ngx-contact-card *ngIf="options?.contacts?.isEnabled && showOption"></ngx-contact-card>
  </div>
</section>
